import { EntityBank } from "../../entity/EntityBank";

export class DtoBanksPostRes extends EntityBank {}
